const SESSION_KEY = 'citymirror_session_id';

let cachedId = null;

export function getSessionId() {
  if (cachedId) return cachedId;
  try {
    const stored = localStorage.getItem(SESSION_KEY);
    if (stored) {
      cachedId = stored;
      return cachedId;
    }
    const newId = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, newId);
    cachedId = newId;
    return cachedId;
  } catch {
    // localStorage unavailable (e.g. private browsing with strict settings)
    if (!cachedId) cachedId = crypto.randomUUID();
    return cachedId;
  }
}
